var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      ref: "block",
      staticClass: "cw-block cw-block-canvas",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.currentTitle) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-canvasblock-toolbar",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cw-canvasblock-buttonset",
                        },
                        [
                          _c("button", {
                            staticClass: "cw-canvasblock-reset",
                            attrs: {
                              title: _vm.$gettext("Zurücksetzen"),
                            },
                            on: {
                              click: _vm.reset,
                            },
                          }),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "cw-canvasblock-undo",
                            attrs: {
                              title: _vm.$gettext("Rückgängig"),
                            },
                            on: {
                              click: _vm.undo,
                            },
                          }),
                          _vm._v(" "),
                          _vm.hasUploadFolder
                            ? _c("button", {
                                staticClass: "cw-canvasblock-store",
                                attrs: {
                                  title: _vm.$gettext(
                                    "Bild im Dateibereich speichern"
                                  ),
                                },
                                on: {
                                  click: _vm.store,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canSwitchView
                            ? _c("button", {
                                class: _vm.viewButtonClass,
                                attrs: {
                                  title: _vm.viewButtonText,
                                },
                                on: {
                                  click: _vm.switchView,
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-canvasblock-buttonset",
                        },
                        _vm._l(_vm.colors, function (color) {
                          return _c("button", {
                            key: color.name,
                            staticClass: "cw-canvasblock-color",
                            class: [
                              _vm.currentColor === color.name
                                ? "selected-color"
                                : "",
                              color.name,
                            ],
                            attrs: {
                              title: color.title,
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setColor(color.name)
                              },
                            },
                          })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-canvasblock-buttonset",
                        },
                        [
                          _c("button", {
                            staticClass:
                              "cw-canvasblock-size cw-canvasblock-size-small",
                            class: {
                              "selected-size": _vm.currentSize === 2,
                            },
                            attrs: {
                              title: _vm.$gettext("klein"),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setSize("small")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("button", {
                            staticClass:
                              "cw-canvasblock-size cw-canvasblock-size-normal",
                            class: {
                              "selected-size": _vm.currentSize === 5,
                            },
                            attrs: {
                              title: _vm.$gettext("normal"),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setSize("normal")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("button", {
                            staticClass:
                              "cw-canvasblock-size cw-canvasblock-size-large",
                            class: {
                              "selected-size": _vm.currentSize === 8,
                            },
                            attrs: {
                              title: _vm.$gettext("groß"),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setSize("large")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("button", {
                            staticClass:
                              "cw-canvasblock-size cw-canvasblock-size-huge",
                            class: {
                              "selected-size": _vm.currentSize === 12,
                            },
                            attrs: {
                              title: _vm.$gettext("riesig"),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setSize("huge")
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-canvasblock-buttonset",
                        },
                        [
                          _c("button", {
                            staticClass:
                              "cw-canvasblock-tool cw-canvasblock-tool-pen",
                            class: {
                              "selected-tool": _vm.currentTool === "pen",
                            },
                            attrs: {
                              title: _vm.$gettext("Zeichenwerkzeug"),
                            },
                            on: {
                              click: function click($event) {
                                return _vm.setTool("pen")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "cw-canvasblock-tool cw-canvasblock-tool-text",
                              class: {
                                "selected-tool": _vm.currentTool === "text",
                              },
                              attrs: {
                                title: _vm.$gettext("Textwerkzeug"),
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.setTool("text")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        T\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    ref: "image",
                    staticClass: "cw-canvasblock-original-img",
                    attrs: {
                      src: _vm.currentUrl,
                    },
                    on: {
                      load: _vm.buildCanvas,
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.textInput,
                        expression: "textInput",
                      },
                    ],
                    ref: "textInputField",
                    staticClass: "cw-canvasblock-text-input",
                    on: {
                      keyup: _vm.textInputKeyUp,
                    },
                  }),
                  _vm._v(" "),
                  _c("canvas", {
                    ref: "canvas",
                    staticClass: "cw-canvasblock-canvas",
                    class: {
                      "cw-canvasblock-tool-selected-pen":
                        _vm.currentTool === "pen",
                      "cw-canvasblock-tool-selected-text":
                        _vm.currentTool === "text",
                    },
                    on: {
                      mousedown: _vm.mouseDown,
                      mousemove: _vm.mouseMove,
                      mouseup: _vm.mouseUp,
                      mouseout: _vm.mouseUp,
                      mouseleave: _vm.mouseUp,
                      touchstart: _vm.touchStart,
                      touchmove: _vm.touchMove,
                      touchend: _vm.touchEnd,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-canvasblock-hints",
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.write,
                              expression: "write",
                            },
                          ],
                          staticClass:
                            "messagebox messagebox_info cw-canvasblock-text-info",
                        },
                        [
                          _c("translate", [
                            _vm._v("Texteingabe mit Enter-Taste bestätigen"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Hintergrundbild")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentImage,
                                      expression: "currentImage",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentImage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "true",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "false",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.currentImage === "true"
                            ? _c(
                                "label",
                                [
                                  _c("translate", [_vm._v("Bilddatei")]),
                                  _vm._v(" "),
                                  _c("courseware-file-chooser", {
                                    attrs: {
                                      isImage: true,
                                    },
                                    on: {
                                      selectFile: _vm.updateCurrentFile,
                                    },
                                    model: {
                                      value: _vm.currentFileId,
                                      callback: function callback($$v) {
                                        _vm.currentFileId = $$v
                                      },
                                      expression: "currentFileId",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Speicherort")]),
                              _vm._v(" "),
                              _c("courseware-folder-chooser", {
                                attrs: {
                                  unchoose: true,
                                },
                                model: {
                                  value: _vm.currentUploadFolderId,
                                  callback: function callback($$v) {
                                    _vm.currentUploadFolderId = $$v
                                  },
                                  expression: "currentUploadFolderId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Werte anderer Nutzer anzeigen"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentShowUserData,
                                      expression: "currentShowUserData",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentShowUserData = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "off",
                                      },
                                    },
                                    [_c("translate", [_vm._v("deaktiviert")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "teacher",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("nur für Lehrende"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "all",
                                      },
                                    },
                                    [_c("translate", [_vm._v("für alle")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Leinwand-Block"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }